import React, {Fragment, useEffect} from "react";
import {observer} from "mobx-react-lite";
import {
    Grid as KendoGrid,
    GRID_COL_INDEX_ATTRIBUTE,
    GridCellProps,
    GridColumn as Column,
    GridFilterChangeEvent,
    GridPageChangeEvent,
    GridSortChangeEvent,
    GridToolbar,
} from "@progress/kendo-react-grid";
import {CompositeFilterDescriptor, filterBy, orderBy, SortDescriptor, State,} from "@progress/kendo-data-query";

import {useStore} from '../../../app/stores/store';
import {Link} from "react-router-dom";
import {Button, Checkbox, Grid, GridRowProps} from "semantic-ui-react";
import {DropdownFilterCell} from "../../../app/common/form/DropDownFilterCell";
import {ExcelExport} from "@progress/kendo-react-excel-export";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import {useTableKeyboardNavigation} from "@progress/kendo-react-data-tools";


export default observer(function ActionIdeaList() {
    const {ideaStore} = useStore();
    const {
        loadActionOwnerIdeas, actionOwnerIdeaRegistry,
        actionOwnerIdeas, loadingInitial
    } = ideaStore;

    const _export = React.useRef(null);
    const excelExport = () => {
        if (_export.current !== null) {
            // @ts-ignore
            _export.current!.save();
        }
    };
    const handleSelectionChange = (event: any) => {
        let newData = data.map((item: any) => {
            if (event.dataItem.title === item.title) {
                item.selected = !item.selected
            }
            return item;
        })
        setData(newData);
    }

    const initialDataState: State = {skip: 0, take: 4};

    const [filter, setFilter] = React.useState<CompositeFilterDescriptor>();
    const [page, setPage] = React.useState<any>(initialDataState);
    const [checked, setChecked] = React.useState<boolean>(false)
    const toggle = () => {
        setChecked(!checked)
    }

    const pageChange = (event: GridPageChangeEvent) => {
        setPage(event.page);
    };
    const initialSort: Array<SortDescriptor> = [
        {field: "createdStamp", dir: "desc"},
    ];
    const [sort, setSort] = React.useState(initialSort);

    const filterChange = (event: GridFilterChangeEvent) => {

        setFilter(event.filter);
        setData(filterBy(actionOwnerIdeas, event.filter));
    };

    const [data, setData] = React.useState(actionOwnerIdeas);
    const diTypes = Array.from(
        new Set(actionOwnerIdeas.map((p) => p.diTypeDescription))
    );

    const DiTypesFilterCell: any = (props: GridCellProps) => (
        <DropdownFilterCell
            {...props}
            data={diTypes}
            defaultValue={"Select Idea Type"}
        />
    );
    let ideaStatus = Array.from(
        new Set(actionOwnerIdeas.map((p) => p.ideaStatusDescription))
    );
    ideaStatus = ideaStatus.filter(status => status != null)

    const IdeaStatusFilterCell: any = (props: GridCellProps) => (
        <DropdownFilterCell
            {...props}
            data={ideaStatus}
            defaultValue={"Select Status"}
        />
    );

    useEffect(() => {
        if (actionOwnerIdeaRegistry.size < 1) loadActionOwnerIdeas();
        setData(actionOwnerIdeas)
    }, [actionOwnerIdeas])

    console.log('actionOwnerIdeas', actionOwnerIdeas)


    const IdeaNumber = (props: any) => {
        const field = props.field || '';
        const value = props.dataItem[field];
        const navigationAttributes = useTableKeyboardNavigation(props.id);
        return (
            <td
                className={props.className}
                style={{...props.style, color: 'blue'}}
                colSpan={props.colSpan}
                role={'gridcell'}
                aria-colindex={props.ariaColumnIndex}
                aria-selected={props.isSelected}
                {...{
                    [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex
                }}
                {...navigationAttributes}
            >
                <Button basic as={Link}
                        to={`/actionOwner/${props.dataItem.ideaId}`}
                        color='blue'
                        size='mini'>
                    {props.dataItem.ideaNumber}
                </Button>

            </td>
        )
    }

    const rowRender = (
        trElement: React.ReactElement<HTMLTableRowElement>,
        props: GridRowProps
    ) => {
        const actionable = !(props.dataItem.processStatusDescription === "Sent To Action Controller For Status Change");
        const green = {backgroundColor: "rgb(55, 180, 0,0.32)"};
        const white = {backgroundColor: "#ffffff"};
        const trProps: any = {style: actionable ? green : white};
        return React.cloneElement(
            trElement,
            {...trProps},
            trElement.props.children
        );
    };

    if (loadingInitial) return <LoadingComponent content='Loading initiatives...'/>
    let dataToExport = checked ? data : filterBy(data, {field: 'selected', operator: 'eq', value: true})
    return (

        <Fragment>
            <ExcelExport data={dataToExport}
                         ref={_export}>
                <KendoGrid className="main-grid" style={{height: "400px"}}
                           data={orderBy(data, sort).slice(page.skip, page.take + page.skip)}
                           sortable={true}
                           sort={sort}
                           onSortChange={(e: GridSortChangeEvent) => {
                               setSort(e.sort);
                           }}
                           skip={page.skip}
                           take={page.take}
                           total={data.length}
                           pageable={true}
                           onPageChange={pageChange}
                           filterable={true}
                           filter={filter}
                           onFilterChange={filterChange}
                           selectedField='selected'
                           onSelectionChange={handleSelectionChange}
                           resizable={true}
                           reorderable={true}
                           rowRender={rowRender}
                >
                    <GridToolbar>
                        <Grid>
                            <Grid.Row columns={2} verticalAlign="middle">
                                <Grid.Column>
                                    <button title="Export Excel" className="k-button k-primary" onClick={excelExport}>
                                        Export to Excel
                                    </button>
                                </Grid.Column>
                                <Grid.Column>
                                    <Checkbox
                                        label='Export All'
                                        onChange={toggle}
                                        checked={checked}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </GridToolbar>
                    <Column field="selected" width="50px" headerCell={() => null} locked/>
                    <Column field="ideaNumber" title="COI#" width={100} cell={IdeaNumber} locked={true}/>
                    <Column field="title" title="COI" width={150} locked={true}/>
                    <Column field="ideaStatusDescription" title="COI Status" width={150}
                            filterCell={IdeaStatusFilterCell}/>
                    <Column field="diTypeDescription" title="COI Type" width={150} filterCell={DiTypesFilterCell}/>
                    <Column field="groupName" title="Location" width={120}/>
                    <Column field="groupLiverDescription" title="Group Lever" width={120}/>
                    <Column field="baseLineParameterDescription" title="Baseline" width={120}/>
                    <Column field="savingCategoryDescription" title="Saving Category" width={150}/>
                    <Column field="processStatusDescription" title="Process Stage" width={150}/>
                    <Column field="createdStamp" title="Created Date" format="{0: dd/MM/yyyy}" width={120}/>
                    <Column field="ideaId" title="COI ID" width={0}/>
                </KendoGrid>
            </ExcelExport>
        </Fragment>
    );
})
